/* A titled part of a page: a white card in the grey content panel (ADR 0019), hairline
   border, 24px padding. A level-3 section inside a card stays flat, so cards never nest.
   The space between stacked cards is the parent's gap (screen.page, a CardGrid, any flex
   column), never a margin here: a margin as well doubled it in every gapped parent. */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
  padding: var(--card-padding);
  border: var(--card-border);
  border-radius: var(--radius-card);
  background: var(--paper);
  box-shadow: var(--shadow-card);
}

.section[data-level='3'] {
  gap: var(--space-3);
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

/* The title row: the title on the left, its controls (a segmented control, a button) on
   the right, like "Next: 7 days | 14 days | 30 days". */
.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2) var(--space-4);
}

.heading {
  display: flex;
  flex: 1 1 10rem;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font: var(--t-heading);
}

.section[data-level='3'] .title {
  font: var(--t-body-strong);
}

.description {
  max-width: 75ch;
  color: var(--graphite);
  font: var(--t-small);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}
